import range from 'lodash/range';
import { utils as utilsCore } from '@industriousapps/excelkits-core';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
import { defaultGrid } from '@/config/univerjs';
// Convert a grid cell reference to a
// position on the grid
export function cellRefsToGridPosition(cellRefs) {
  let topOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let sheetData = arguments.length > 2 ? arguments[2] : undefined;
  let grid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const [first, last] = spreadsheetCore.cellReferencesToAddress(cellRefs);
  const {
    width: sheetWidth,
    height: sheetHeight
  } = utilsCore.getMatrixDimensions(sheetData);
  const lastCol = last ? last.col : first.col;
  const lastRow = last ? last.row : first.row;
  const width = calcTotalWidth(first.col, lastCol, isFinite(lastCol) ? Infinity : sheetWidth, // Restrict infinite
  grid.columnData);
  const height = calcTotalHeight(first.row, lastRow, isFinite(lastRow) ? Infinity : sheetHeight, // Restrict infinite
  grid.rowData);
  const top = calcTopOffset(first.row, grid.rowData) + topOffset;
  const left = calcLeftOffset(first.col, grid.columnData);
  return {
    width,
    height,
    top,
    left
  };
} // Calculate width of an item based
// on a dynamic/customizable grid

export function calcTotalWidth(firstCol, lastCol, sheetMaxColumns) {
  let gridColumns = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // Treat infinite first as 0
  const firstColTarget = isFinite(firstCol) ? firstCol : 0; // Limit max column to last column ref or sheet widgth

  const lastColTarget = Math.min(lastCol + 1, sheetMaxColumns);
  return range(firstColTarget, lastColTarget).reduce((acc, colIndex) => {
    const customCol = gridColumns[colIndex] && gridColumns[colIndex].w;
    acc += typeof customCol === 'number' && !isNaN(customCol) ? gridColumns[colIndex].w || defaultGrid.columnWidth : defaultGrid.columnWidth;
    return acc;
  }, 0);
} // Calculate height of an item based
// on a dynamic/customizable grid

export function calcTotalHeight(firstRow, lastRow, sheetMaxRows) {
  let gridRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // Treat infinite first as 0
  const firstRowTarget = isFinite(firstRow) ? firstRow : 0; // Limit max row to last row ref or sheet height

  const lastRowTarget = Math.min(lastRow + 1, sheetMaxRows);
  return range(firstRowTarget, lastRowTarget).reduce((acc, rowIndex) => {
    const customCol = gridRows[rowIndex] && gridRows[rowIndex].h;
    acc += typeof customCol === 'number' && !isNaN(customCol) ? gridRows[rowIndex].h || defaultGrid.rowHeight : defaultGrid.rowHeight;
    return acc;
  }, 0);
} // Calculate left position of an item
// in a dynamic/customizable grid

export function calcLeftOffset(firstCol) {
  let gridColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Treat infinite first as 0
  const firstColTarget = isFinite(firstCol) ? firstCol : 0;
  return range(0, firstColTarget).reduce((acc, colIndex) => {
    const customCol = gridColumns[colIndex] && gridColumns[colIndex].w;
    acc += typeof customCol === 'number' && !isNaN(customCol) ? gridColumns[colIndex].w || defaultGrid.columnWidth : defaultGrid.columnWidth;
    return acc;
  }, 0);
} // Calculate top position of an item
// in a dynamic/customizable grid

export function calcTopOffset(firstRow) {
  let gridRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Treat infinite first as 0
  const firstRowTarget = isFinite(firstRow) ? firstRow : 0;
  return range(0, firstRowTarget).reduce((acc, rowIndex) => {
    const customCol = gridRows[rowIndex] && gridRows[rowIndex].h;
    acc += typeof customCol === 'number' && !isNaN(customCol) ? gridRows[rowIndex].h || defaultGrid.rowHeight : defaultGrid.rowHeight;
    return acc;
  }, 0);
} // Hack to increase probability dep loading
// has completed & Univer is ready to scroll

export const delayInitialUniverCmd = (hasLoaded, cb) => {
  setTimeout(cb, hasLoaded ? 0 : 400);
};